import "../../styles/job_registration.css";
import JobTypeIcon from "../../assets/job_registration/Job_type.png";
import LocationIcon from "../../assets/job_registration/Location.png";
import ExperienceIcon from "../../assets/job_registration/Experience.png";
import GenderIcon from "../../assets/job_registration/Gender.png";
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useState } from "react";
import { jobRegistrationSchema } from "../../utils/schema";
import { applyForJob } from "../../ts-lib/cg-job/features/Jobs/services/jobsAPI";

const JobCgDetail = ({isModalOpen,setIsModalOpen, job, setFailMessage, setSuccessMessage, setIsFailVisibleFade, setIsSuccessVisibleFade, setJob}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState("");
    const [mobile, setMobile] = useState("");

    const onSubmit = async () => {
        setIsLoading(true);

        try {
            const jobRegistrationPayload = {
                name: name,
                mobile: mobile,
                caregiver_id: null,
                from: "job_registration"
              }

            await jobRegistrationSchema.validate({
                job_id: job?.id,
                name: name,
                mobile: mobile,
            });

            const newJob = {...job, total_interest: job.total_interest+1}
            // insert into db
            const response = await applyForJob(job?.id, jobRegistrationPayload);
            if (response?.insertId){
                setJob(newJob);
                setIsModalOpen(false);
                setSuccessMessage("You've successfully registered for this job.");
                setIsSuccessVisibleFade(true);
            }
        } catch (err) {
            alert(err);
            setFailMessage(`Error: ${err}. Please try again.`);
            setIsFailVisibleFade(true);
        }
        
        setIsLoading(false)
    }

    const capitalized = (str) => {
        return str?.charAt(0).toUpperCase() + str?.slice(1);
    }

    return (
        <>
            <div style={{border: "2px solid", borderRadius: "10px", padding: 10, borderColor:"#5A46AA"}}>
                <Modal isOpen={isModalOpen}>
                    <ModalHeader>Apply For Job</ModalHeader>
                    <ModalBody>
                        <form>
                            <Row style={{marginBottom: 10}}>
                                <Col md={3} style={{display: "flex", flexWrap:"wrap", alignItems: "center"}}><label>Name:</label></Col>
                                <Col>
                                    <input 
                                        type = "text"
                                        style={{width: "100%", borderColor: "#5A46AA", borderStyle: "solid", borderWidth: "1px", borderRadius: 5, height: 40}}
                                        onChange={(e) => {setName(e.target.value)}}
                                    />
                                </Col>
                            </Row>
                            
                            <Row>
                                <Col md={3} style={{display: "flex", flexWrap:"wrap", alignItems: "center"}}><label>Mobile:</label></Col>
                                <Col>
                                    <input 
                                        type = "text"
                                        style={{width: "100%", borderColor: "#5A46AA", borderStyle: "solid", borderWidth: "1px", borderRadius: 5, height: 40}}
                                        onChange={(e) => {setMobile(e.target.value)}}
                                    />
                                </Col>
                            </Row>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="t-reject-button" onClick={() => {setIsModalOpen(false)}}>Cancel</button>
                        <button 
                            onClick={()=> {onSubmit()}}
                            disabled={isLoading}
                            className="t-accept-button"
                        >
                            {
                                isLoading?(
                                <center><Spinner /></center>) : "Submit"
                            }
                        </button>
                    </ModalFooter>
                </Modal>
                <div style={{display:"flex", justifyContent:"space-between", marginBottom:10}}>
                    <div style={{fontSize: 25, fontWeight: 500}}>
                        {capitalized(job?.role)}
                    </div>
                    <div className="j-button-container">
                        <button className="j-apply-button" onClick={() => {setIsModalOpen(true)}}>Apply Now</button>
                    </div>
                </div>
                <div style={{display:"flex", marginBottom: 10}}>
                    <img style={{width:30, height:30}} src= {JobTypeIcon} alt={JobTypeIcon}/>
                    <div style={{margin:"auto", marginLeft: 5}}>{`${job?.job_type ?? "Full Time / Locuum"}`}</div>
                </div>
                <div style={{display:"flex", marginBottom: 10}}>
                    <img style={{width:30, height:30}} src= {LocationIcon} alt={LocationIcon}/>
                    <div style={{margin:"auto", marginLeft: 5}}>{job?.job_details? `${job?.job_details[0]?.location ?? "-"}` : `${job?.job_location ?? "-"}`}</div>
                </div>
                <div style={{display:"flex", marginBottom: 10}}>
                    <img style={{width:30, height:30}} src= {ExperienceIcon} alt={ExperienceIcon}/>
                    <div style={{margin:"auto", marginLeft: 5}}>{`${job?.job_experience ?? "-"}`}</div>
                </div>
                <div style={{display:"flex"}}>
                    <img style={{width:30, height:30}} src= {GenderIcon} alt={GenderIcon}/>
                    <div style={{margin:"auto", marginLeft: 5}}>{job?.job_details? `${capitalized(job?.job_details[0]?.gender) ?? "Prefer not to say"}` : `${job?.job_gender ?? "Prefer not to say"}`}</div>
                </div>
                <div className="j-button-container-bottom">
                    <button className="j-apply-button" onClick={() => {setIsModalOpen(true)}}>Apply Now</button>
                </div>
            </div>
        </>
    )
}

export default JobCgDetail;
